<template>
  <div class="el-container">
    <CompanyProfile v-if="$route.params.type === 'companyProfile'" />
    <CompanyHonors v-if="$route.params.type === 'honor'" />
    <News v-if="$route.params.type === 'news'" />
  </div>
</template>

<script>
import CompanyProfile from './about/CompanyProfile'
import CompanyHonors from './about/CompanyHonors'
import News from './News'
export default {
  name: 'AboutUs',
  components: {
    CompanyProfile,
    CompanyHonors,
    News
  },
  data: () => {
    return {

    }
  },
  mounted() {
    this.$route.params.type === 'companyProfile' && this.$emit('checkBanner', !0)
  },
  methods: {

  }

}
</script>

<style scoped lang="scss">
</style>
